import { useMemo, useState } from "react";
import { notificacion, notificacionError } from "../../../../components/Alerts";
import { BaseModal, ModalCloseCross, type BaseModalProps } from "../../../../components/modals/BaseModal";
import { TypedTable } from "../../../../components/TypedTable";
import { ComunicacionAjax } from "../../../../ts/api/comunicacion";
import type { Respuesta } from "../../../../ts/typings/clases";
import { createColumnHelper } from "@tanstack/react-table";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Loading, QueryError } from "../../../../components/Loading/Loading";

interface ModalPuestoProps extends BaseModalProps {
	readonly idPuesto: string;
}
export function ModalPuesto(props: ModalPuestoProps) {
	const [creating, setCreating] = useState(false);

	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h4 className="modal-title">Puesto {props.idPuesto}</h4>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body" style={{ minWidth: "600px" }}>
				<div className="content-box big-box">
					{!creating && (
						<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: "2%", gap: "2em" }}>
							<h1>Subpuestos</h1>
							<button type="button" className="btnPrimary" onClick={() => setCreating(true)}>
								Nuevo subpuesto
							</button>
						</div>
					)}

					{creating ? (
						<EdicionSubpuesto
							idPuesto={props.idPuesto}
							setCreating={setCreating}
						/>
					) : null}

					<div className="table-responsive" style={{ marginBottom: "2%" }}>
						<TablaSubpuestos idPuesto={props.idPuesto} />
					</div>
				</div>
			</div>
			<div className="modal-footer">
				<button type="button" className="btnSecondary" onClick={props.close}>
					Cerrar
				</button>
			</div>
		</BaseModal>
	);
}
function TablaSubpuestos(props: { readonly idPuesto: string; }) {
	const { data, error, isPending } = useSubPuestos(props.idPuesto);

	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<Subpuesto>();

		const getAcciones = (subpuesto: Subpuesto) => <AccionesSubPuesto subpuesto={subpuesto} idPuesto={props.idPuesto} />;

		return [
			columnHelper.accessor("codigo_subpuesto", { header: "Codigo", meta: { className: "dt-center" } }),
			columnHelper.accessor("nombre", { header: "Nombre", meta: { className: "dt-center" } }),
			columnHelper.display({
				id: "acciones",
				header: "",
				cell: ({ row }) => getAcciones(row.original),
			})
		];
	}, [props.idPuesto]);

	if (error) return <QueryError error={error} fallback="Error cargando los subpuestos." />;
	if (isPending) return <Loading />;

	return (
		<TypedTable
			// "scrollY": "400px",
			// "scrollCollapse": true,
			className="dataTable display"
			data={data}
			columns={columns}
		/>
	);
}

interface EditarSubpuestoProps {
	readonly idPuesto: string;
	readonly setCreating: (creating: boolean) => void;
}
function EdicionSubpuesto(props: EditarSubpuestoProps) {
	// $(document).on("click", ".mostrarEditSubpuesto", function () {
	// 	const data = tabla.row(row).data() as Subpuesto;


	// 	$("#codigoSubpuesto").val(data.codigo_subpuesto);
	// 	$("#nombreSubpuesto").val(data.nombre);

	// 	$("#divEditarSubpuestos").show();
	// 	$("#botonGuardarNuevoSubpuesto").attr("tipo", "editar");
	// 	$("#botonGuardarNuevoSubpuesto").attr("idPuesto", data.id);
	// 	$("#botonGuardarNuevoSubpuesto").removeAttr("idPuestoPadre");
	// 	$("#botonGuardarNuevoSubpuesto").data("rowCaller", row);
	// });

	const queryClient = useQueryClient();
	const [nameSubpuesto, setNameSubpuesto] = useState("");
	const [codeSubpuesto, setCodeSubpuesto] = useState("");

	const guardarSubpuesto = () => {
		void ComunicacionAjax.sendAjaxRequest<RespuestaSubpuesto>("POST", "/editarSubpuesto", {
			tipo: "anadir",
			idPuestoPadre: props.idPuesto,
			codigo: codeSubpuesto,
			nombre: nameSubpuesto,
		}).then((response) => {
			if (response.tipo != "exito") {
				notificacionError(response.message);
				return;
			}

			props.setCreating(false);
			return queryClient.invalidateQueries({ queryKey: ["getSubpuestos", props.idPuesto] });
		});
	};

	return (
		<div style={{ display: "grid", gridTemplateColumns: "1fr 2fr 1fr 3fr", gap: "1em", alignItems: "baseline", padding: "10px 2em", paddingTop: "0", border: "1px solid #ccc", borderRadius: "8px", marginBottom: "2%" }}>
			<h1 style={{ gridColumn: "span 4" }}>Creando Subpuesto</h1>

			<label className="labelsForm" style={{ margin: "0" }}>
				Id
			</label>
			<input
				type="text"
				className="inputsForm"
				value={codeSubpuesto}
				onChange={(e) => setCodeSubpuesto(e.target.value)}
			/>

			<label className="labelsForm" style={{ margin: "0" }}>
				Nombre
			</label>

			<input
				type="text"
				className="inputsForm"
				value={nameSubpuesto}
				onChange={(e) => setNameSubpuesto(e.target.value)}
			/>

			<button style={{ gridColumn: "span 2" }} type="button" className="btnSecondary" onClick={() => props.setCreating(false)}>
				Cancelar
			</button>
			<button style={{ gridColumn: "span 2" }} type="button" className="btnPrimary" onClick={guardarSubpuesto}>
				Guardar
			</button>
		</div>
	);
}

function AccionesSubPuesto(props: { readonly subpuesto: Subpuesto, readonly idPuesto: string; }) {
	const queryClient = useQueryClient();


	const onConfirmarEliminar = () => {
		void ComunicacionAjax.sendAjaxRequest<Respuesta>("POST", "/eliminarSubpuesto", {
			"idSubpuesto": props.subpuesto.id,
		}).then((res) => {
			if (res.tipo != "exito") {
				notificacionError(res.message ?? "Error eliminando el subpuesto.");
				return;
			}
			notificacion(res.message ?? "Subpuesto eliminado correctamente.");
			return queryClient.invalidateQueries({ queryKey: ["getSubpuestos", props.idPuesto] });
		});
	};
	const onEliminar = () => {
		if (window.confirm("¿Está seguro que desea eliminar este subpuesto?")) {
			onConfirmarEliminar();
		}
	};


	return (
		<div style={{ display: "flex", justifyContent: "center" }}>
			{/* <button className="icon-round youtube-bg btnIcon mostrarEditSubpuesto">
				<i className="fa fa-pen-to-square" />
			</button> */}
			<button className="main-color btnIcon" onClick={onEliminar} type="button">
				<i className="fa fa-trash" style={{ fontSize: 20 }} />
			</button>
		</div>
	);
}


function useSubPuestos(idPuesto: string) {
	return useQuery({
		queryKey: ["getSubpuestos", idPuesto],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<Subpuesto[]>("GET", "/getSubpuestos", {
				"idPuesto": idPuesto
			});
		},
	});
}
interface Subpuesto {
	id: number;
	codigo_padre: string;
	codigo_subpuesto: string;
	nombre: string;
}


// async function editarSubpuesto(parametros: OptionsCrear | OptionsEdit, row?: JQuery | null): Promise<void> {
// 	const response = await ComunicacionAjax.sendAjaxRequest("POST", "/editarSubpuesto", parametros) as RespuestaSubpuesto;

// 	if (response.tipo != "exito") {
// 		notificacionError(response.message);
// return
// 	}
// }

type RespuestaSubpuesto = {
	tipo: "exito";
	subpuesto: Subpuesto;
} | {
	tipo: "error";
	message: string;
};
